import { createStyles } from "antd-style";
import { useBreakpoint } from "@/base/utils/index";

export const useStyles = createStyles(({ css }: any) => ({
  modal: css``,
  content: css``,
  contentImage: css`
    overflow: hidden;
    position: relative;

    & > img {
      margin: auto;
      width: 100%;
    }
  `,
  contentDescription: css`
    height: 100%;
  `,
}));

export const useModalProductViewStyles = () => {
  const screens = useBreakpoint();
  const styles = useStyles(screens);

  return styles;
};
